// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__ZnlQj","label":"LabeledBox_label__2QcPz"};